module.exports = __webpack_public_path__ + "static/media/onmission-csv-template.5b30a77c.csv";